import { IconArrowInbox } from 'central-icons/IconArrowInbox';

import { Button } from '@revelio/ui';

/** Download link pinned beside the modal close button, shared by the preview
 *  modals. */
export const ModalDownloadButton = ({
  downloadUrl,
}: {
  downloadUrl: string;
}) => (
  <Button asChild color="secondary" variant="ghost" size="sm">
    <a
      title="Download file"
      href={downloadUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download file"
      style={{ position: 'absolute', top: '0.5rem', right: '3rem' }}
    >
      <span aria-hidden="true">
        <IconArrowInbox size={16} />
      </span>
      <span>Download</span>
    </a>
  </Button>
);
